module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [(_vm.showMedia) ? _c('div', {
    staticClass: "row voice"
  }, [_c('m-voice')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      paddingTop10: _vm.h5
    },
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "response",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": "static/images/slogan.png"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row zhi slogon"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "zhi-item"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "zhi-item-intro"
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('span', [_vm._v("3+5按需定制")]), _c('label', {
    on: {
      "click": function () {
        this$1.$emit('on-openDialog')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/what.png"
    }
  })])])])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "response",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": _vm.VSSrc
    }
  })]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    attrs: {
      "href": "static/docs/baoxiantiaokuan.html",
      "target": "_blank"
    },
    on: {
      "click": function () {
        this$1.$emit('on-recordScroll')
      }
    }
  }, [_vm._v("保险条款")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "static/docs/xinxipilou.html",
      "target": "_blank"
    },
    on: {
      "click": function () {
        this$1.$emit('on-recordScroll')
      }
    }
  }, [_vm._v("信息披露")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "response",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": "static/images/uses.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/item_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zhi-item"
  }, [_c('div', [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/feature_1.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhi-item-intro"
  }, [_c('p', [_vm._v("投保年龄"), _c('span', [_vm._v("(宽)")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('span', [_vm._v("18-60周岁")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zhi-item"
  }, [_c('div', [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/feature_2.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhi-item-intro"
  }, [_c('p', [_vm._v("保障责任"), _c('span', [_vm._v("(全)")])]), _vm._v(" "), _c('p', {
    staticClass: "small exclamation"
  }, [_c('span', [_vm._v("身故及全残")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/feature_3.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("保险方式"), _c('span', [_vm._v("(多)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zhi-item"
  }, [_c('div', [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/feature_4.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhi-item-intro"
  }, [_c('p', [_vm._v("等待期"), _c('span', [_vm._v("(短)")])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_c('span', [_vm._v("90天")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/item_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("人寿保险成本结构对比")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/item_3.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "6px"
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("同类定期寿险对比 "), _c('span', [_vm._v("(以女性，100万保额，20年交，保30年为例)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row image-pk"
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/pk.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "niu",
    attrs: {
      "src": "static/images/niu.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c01de5d2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = 666
// module chunks = 1